import { computed, inject, Injectable } from '@angular/core';
import {
  DefaultRequiredLanguagesProvider,
  LanguageStore,
  REQUIRED_LANGUAGE_PROVIDER,
  RequiredLanguagesProvider,
} from '@digiwall/core';
import { combineLatest, map, Observable } from 'rxjs';
import { CurrentCompanyStore } from '../companies/company.store';

@Injectable({ providedIn: 'root' })
export class CompanyRequiredLanguagesProvider implements RequiredLanguagesProvider {
  private languageStore = inject(LanguageStore);
  private currentCompanyStore = inject(CurrentCompanyStore);
  private defaultProvider = inject(DefaultRequiredLanguagesProvider);

  readonly requiredLanguages = computed(() => {
    const currentCompany = this.currentCompanyStore.currentCompany();
    let companyLanguageIds = currentCompany.requiredTranslatedLanguageIds;
    if (!(companyLanguageIds?.length > 0)) {
      companyLanguageIds = [currentCompany.languageId];
    }
    const languages = this.languageStore.translatedLanguages();
    const defaultRequired = this.defaultProvider.requiredLanguages();

    const result = companyLanguageIds
      .filter(x => x != null)
      .map(x => languages.find(l => l.id == x));
    return result.length > 0 ? result : defaultRequired;
  });

  ensureLoaded(): Observable<void> {
    return combineLatest([
      this.languageStore.ensureLoaded(),
      this.currentCompanyStore.ensureLoaded(),
    ]).pipe(map(() => {}));
  }
}

export function provideRequiredLanguagesProvider() {
  return {
    provide: REQUIRED_LANGUAGE_PROVIDER,
    useExisting: CompanyRequiredLanguagesProvider,
  };
}
